import { apiConfig } from '../../../common/apiConfig'
import { createUserStore } from '../../../common/user/createUserStore'
import {
  ApproverProfileApi,
  SignOutRequestRoleEnum,
  UserSessionsApi,
  UserSignInRequestRoleEnum,
} from '../../../generated'

const api = new ApproverProfileApi(apiConfig)
const sapi = new UserSessionsApi(apiConfig)

const _load = api.currentApproverProfile.bind(api)

async function _signIn(account: string, password: string, keep: boolean) {
  return sapi.userSignIn({ account, password, keep, role: UserSignInRequestRoleEnum.Approve })
}

async function _signOut() {
  return sapi.userSignOut({ role: SignOutRequestRoleEnum.Approve })
}

export const { signOut, onSignOut, onError, useUser } = createUserStore(_load, _signIn, _signOut)
